import React from "react";
import { getDayName } from "../../../utils/dateUtils";
import AttendanceCell from "./AttendanceCell";
import TotalsCell from "./TotalsCell";
import { capitalize } from "../../../components/common/capitalize";

const columnOrder = ["P", "T", "C", "L", "I"];

const AttendanceGrid = ({
  days,
  teamMembers,
  attendanceData,
  onAttendanceChange,
  calculateTotals,
}) => {
  const totalDaysInView = days.length;

  if (!days?.length || !teamMembers?.length) {
    return <p>No data available</p>;
  }

  const membersByTeam = teamMembers.reduce((groups, member) => {
    const team = member.team || "No Team";
    if (!groups[team]) groups[team] = [];
    groups[team].push(member);
    return groups;
  }, {});

  return (
    <div className="attendance-grid">
      {/* ───── Header rows ───── */}
      <div className="attendance-grid-header">
        <div className="attendance-legend">
          <span><strong>P</strong>: PTO</span>
          <span><strong>T</strong>: Tardy</span>
          <span><strong>C</strong>: Call In</span>
          <span><strong>L</strong>: Leave Early</span>
          <span><strong>I</strong>: Incentive Day</span>
        </div>

        <div className="attendance-header-row day-names">
          <div className="team-member-header">Team Members</div>
          {days.map((day) => (
            <div key={day.toISOString()} className="attendance-header-cell">
              {getDayName(day)}
            </div>
          ))}
          {columnOrder.map((key) => (
            <div key={key} className="attendance-header-cell totals-col">
              {key}
            </div>
          ))}
        </div>

        <div className="attendance-header-row day-numbers">
          <div className="team-member-header"></div>
          {days.map((day) => (
            <div key={day.toISOString()} className="attendance-header-cell">
              {day.getDate()}
            </div>
          ))}
          {columnOrder.map((key) => (
            <div key={key} className="attendance-header-cell totals-col"></div>
          ))}
        </div>
      </div>

      {/* ───── Grid body ───── */}
      <div className="grid-body">
        {Object.entries(membersByTeam).map(([teamName, members]) => (
          <React.Fragment key={teamName}>
            <div className="team-separator-row">{teamName}</div>

            {members.map((member) => (
              <div key={member.id} className="grid-row">
                {/* name column */}
                <div className="team-member-item">
                  {capitalize(member.first_name)} {capitalize(member.last_name)}
                </div>

                {/* day cells */}
                {days.map((day) => {
                  const dayString = day.toISOString().split("T")[0];
                  const record = attendanceData.find(
                    (entry) =>
                      entry.userId === member.id && entry.date === dayString
                  );

                  return (
                    <div key={`${member.id}-${dayString}`} className="attendance-cell-wrapper">
                      <AttendanceCell
                        code={record?.key || ""}
                        note={record?.notes || ""}
                        updatedBy={record?.updatedBy}
                        recordId={record?.id}               /* 👈 NEW prop */
                        onChange={(rId, newCode, newNote) =>
                          onAttendanceChange(rId, member.id, day, newCode, newNote)
                        }
                      />
                    </div>
                  );
                })}

                {/* totals */}
                <TotalsCell
                  totals={calculateTotals(member.id)}
                  columnOrder={columnOrder}
                  totalDays={totalDaysInView}
                />
              </div>
            ))}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default AttendanceGrid;
